import { createTheme } from "@mui/material/styles";

import form from "./form";
import palette from "./palette";
import typography from "./typography";

const defaultNiapTheme = createTheme({
  palette,
  typography,
  components: {
    ...form,
  },
});

export default defaultNiapTheme;
